import { CTA } from "common/styleguide/CTA";
import { userAgentIsIOS } from "lib/mobileDeviceChecks";
import React from "react";

// Button that, when clicked, will either open the provided
// resource in our mobile app or redirect the user to
// the app store to download the app
export class OpenInAppButton extends React.PureComponent {
  static defaultProps = {
    buttonText: "Open in App",
  };

  render() {
    // iOS will natively display an open in app button thanks to our apple-itunes-app meta tag, so we only want this for Android
    if (userAgentIsIOS()) return <></>;

    const { buttonText, appLink, ...ctaProps } = this.props;

    const [scheme, path] = appLink.split("://");
    const uri = `intent://${path}#Intent;package=com.ridewithgps.mobile;scheme=${scheme};end;`;

    return (
      <CTA href={uri} {...ctaProps}>
        {buttonText}
      </CTA>
    );
  }
}
